/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AttachAttachment } from '../models/AttachAttachment';
import type { AttachmentInfo } from '../models/AttachmentInfo';
import type { AttachmentToInsert } from '../models/AttachmentToInsert';
import type { Body_create_new_attachment_form_api_v1_attachments_new_post } from '../models/Body_create_new_attachment_form_api_v1_attachments_new_post';
import type { Body_upload_attachment_chunk_api_v1_attachments_chunk_post } from '../models/Body_upload_attachment_chunk_api_v1_attachments_chunk_post';
import type { ReorderAttachments } from '../models/ReorderAttachments';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AttachmentsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List All Attachments
     * List metadata for every attachment stored in the system.
     * @returns AttachmentInfo Successful Response
     * @throws ApiError
     */
    public listAllAttachmentsApiV1AttachmentsListGet(): CancelablePromise<Array<AttachmentInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/attachments/list',
        });
    }
    /**
     * Reorder Object Attachments
     * Set display order for attachments on an object.
     * @returns any Successful Response
     * @throws ApiError
     */
    public reorderObjectAttachmentsApiV1AttachmentsOrderObjectIdPut({
        objectId,
        requestBody,
    }: {
        objectId: number,
        requestBody: ReorderAttachments,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/attachments/order/{object_id}',
            path: {
                'object_id': objectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Detach Attachment From Object
     * Remove the association between an attachment and an object. The file is preserved.
     * @returns any Successful Response
     * @throws ApiError
     */
    public detachAttachmentFromObjectApiV1AttachmentsDetachObjectIdAttachmentUuidDelete({
        objectId,
        attachmentUuid,
    }: {
        objectId: number,
        attachmentUuid: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/attachments/detach/{object_id}/{attachment_uuid}',
            path: {
                'object_id': objectId,
                'attachment_uuid': attachmentUuid,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Attach Existing Attachment To Object
     * Attach (or move) an existing attachment to another object.
     * @returns string Successful Response
     * @throws ApiError
     */
    public attachExistingAttachmentToObjectApiV1AttachmentsAttachPut({
        requestBody,
    }: {
        requestBody: AttachAttachment,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/attachments/attach',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create New Attachment Form
     * Create an attachment from a multipart form upload. Returns the attachment UUID.
     * @returns string Successful Response
     * @throws ApiError
     */
    public createNewAttachmentFormApiV1AttachmentsNewPost({
        formData,
    }: {
        formData: Body_create_new_attachment_form_api_v1_attachments_new_post,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/attachments/new',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Attachment Chunk
     * Accept one chunk of a chunked upload.  When the last chunk arrives all
     * chunks are assembled in order, the attachment is created, and the response
     * includes the new attachment UUID.  Intermediate responses report progress.
     * @returns any Successful Response
     * @throws ApiError
     */
    public uploadAttachmentChunkApiV1AttachmentsChunkPost({
        formData,
    }: {
        formData: Body_upload_attachment_chunk_api_v1_attachments_chunk_post,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/attachments/chunk',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create New Attachment
     * Create an attachment from a base64-encoded JSON body. Returns the attachment UUID.
     * @returns string Successful Response
     * @throws ApiError
     */
    public createNewAttachmentApiV1AttachmentsPut({
        requestBody,
    }: {
        requestBody: AttachmentToInsert,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/attachments/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Attachment Info
     * Return attachment metadata including how many objects it is attached to.
     * @returns AttachmentInfo Successful Response
     * @throws ApiError
     */
    public getAttachmentInfoApiV1AttachmentsAttachmentUuidInfoGet({
        attachmentUuid,
    }: {
        attachmentUuid: string,
    }): CancelablePromise<AttachmentInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/attachments/{attachment_uuid}/info',
            path: {
                'attachment_uuid': attachmentUuid,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Serve Attachment
     * Serve the attachment file as a download.
     * @returns any Successful Response
     * @throws ApiError
     */
    public serveAttachmentApiV1AttachmentsAttachmentUuidGet({
        attachmentUuid,
    }: {
        attachmentUuid: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/attachments/{attachment_uuid}',
            path: {
                'attachment_uuid': attachmentUuid,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Attachment
     * Hard-delete: remove all object links, delete file from disk, remove DB row.
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteAttachmentApiV1AttachmentsAttachmentUuidDelete({
        attachmentUuid,
    }: {
        attachmentUuid: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/attachments/{attachment_uuid}',
            path: {
                'attachment_uuid': attachmentUuid,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
